import { Component } from '@angular/core';

@Component({
  selector: 'app-copy-from',
  templateUrl: './copy-from.component.html',
  styleUrls: ['./copy-from.component.css']
})
export class CopyFromComponent {

  displayedColumns: string[] = ['base_document', 'item_no', 'bp_catalog_no', 'item_desc', 
  'qty', 'unit_price', 'discount', 'total', 'departments', 'line_of_business', 
  'dimension_3', 'dimension_4', 'dimension_5', 'uom_code', 'unit_name', 'qty_inventory', 'branch'];
  dataSource :any = [
    {}, {}
  ];


  ngOninit(){
    console.log('dataSource',this.dataSource)
  }

}
